import React from 'react';
import { withRouter } from 'react-router';
import Navbar from '../Navbar/navbar.jsx';
import { isLogin } from '../../utils/authentication.js';
import _ from 'lodash'
import axios from 'axios';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import { Link } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner'
import { BACKEND_URL_MAIN, BACKEND_URL, COMMUNITY_URL } from '../../config.js';

const ReportList = () => {
    const [isOptionsLoadin, setisOptionsLoadin] = React.useState(false)
    const [data, setData] = React.useState([]);
    const [report, setReport] = React.useState([]);
    const [reportTitle, setReportTitle] = React.useState([]);
    const [parentId, SetParentId] = React.useState("")
    const [show, setShow] = React.useState(false);
    const [title, setTitle] = React.useState("");
    const [loader, setLoader] = React.useState(false)
    const [description, setDescription] = React.useState("");
    const [sucess, setSuccess] = React.useState(false);
    const [keyword, setKeyword] = React.useState("");

    const fetchQuestion = async () => {
        setLoader(true)
        const response = await fetch(BACKEND_URL_MAIN + `/v1/client/searchNew?search=i`);
        const data = await response.json();
        setReport(data)
        setReportTitle(data.list)
        setLoader(false)
    }
    const getAllList = () => {
        axios.get(
            `${BACKEND_URL}/v1/explore/demousers`,
            {
                headers: {
                    token: localStorage.getItem("token")
                }
            }
        ).then((res) => {
            setData(res.data)
            setisOptionsLoadin(false)
        }).catch((err) => {
            setisOptionsLoadin(false)
        })
    }
    const onEditModal = async (id) => {
        setShow(true)
        const response = await fetch(COMMUNITY_URL + `/v1/metadata?parentId=${id}&parentType=REPORT`);
        const data = await response.json();
        SetParentId(id)
        if (data.results) {
            setDescription(data.results.description);
            setKeyword(data.results.keyword)
            setTitle(data.results.title);
            SetParentId(id)
        }
        else {
            setDescription("");
            setKeyword("")
            setTitle("");
            SetParentId(id)
        }
    }
    const onEditClose = () => {
        setShow(false)
    }
    const postMeta = (evt) => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            "title": title,
            "description": description,
            "keyword": keyword,
            "parentId": parentId ? parentId : "",
            "parentType": "REPORT"

        });
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        fetch(COMMUNITY_URL + `/v1/metadata/create`, requestOptions).then(response => setSuccess(response.ok)).catch(error => console.log('error', error));
        evt.preventDefault();
        setShow(false)
    }
    React.useEffect(() => {
        if (!isLogin()) {
            window.location.href = "/login"
        } else {
            setisOptionsLoadin(true)
            getAllList();
            fetchQuestion()
        }
    }, [])
    return (
        <div>
            <div className="col-md-12 topbar">
                <Navbar />
            </div>
            <main role="main" className="p-5">
                <div class="d-flex justify-content-center">
                    <h3>CMS Reports</h3>
                </div>
                <div class="d-flex justify-content-center">
                    <nav className="my-2 my-md-0 mr-md-3">
                        <Link to="/cms-question" style={{ borderRight: '1px solid #cfcfcf' }} className="p-2 text-dark">Question Answers</Link>
                        <Link to="/cms-market" style={{ borderRight: '1px solid #cfcfcf' }} className="p-2 text-dark">Market statistics</Link>
                    </nav>
                </div>
                <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Serial No.</th>
                                <th scope="col">Report Name</th>
                                <th scope="col">Sector</th>
                                <th scope="col">Edit</th>
                            </tr>
                        </thead>
                        {!loader ? <tbody>
                            {reportTitle.map((t, i) => {
                                return (
                                    <tr>
                                        <th scope="row">{i + 1}</th>
                                        <td>{t.reportName}</td>
                                        <td>{t.industryType}</td>
                                        <td>
                                            <button type="button" class="btn btn-info" data-toggle="modal" data-target="#exampleModalCenter" onClick={() => onEditModal(t._id)} >Edit</button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody> : <div className="d-flex justify-content-center"> <Loader
                            type="Oval"
                            color="#00BFFF"
                            height={50}
                            width={50}
                        //    timeout={3000} //3 secs
                        /></div>}
                    </table>
                </div>
                <Modal show={show} onHide={onEditClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Report Metadat</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={postMeta}>
                            <div class="form-group">
                                <label for="exampleInputEmail1"><b>Meta Title</b></label>
                                <input class="form-control" aria-describedby="emailHelp" value={title} placeholder="Enter Meta title" onChange={(e) => setTitle(e.target.value)} required/>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputEmail1"><b>Meta Desciption</b></label>
                                <textarea class="form-control" aria-describedby="emailHelp" value={description} placeholder="Enter meta description" onChange={(e) => setDescription(e.target.value)} required/>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputEmail1"><b>Meta Tags</b></label>
                                <textarea class="form-control" aria-describedby="emailHelp" value={keyword} placeholder="Enter tags" onChange={(e) => setKeyword(e.target.value)} required/>
                            </div>
                            <button type="submit" class="btn btn-primary">Submit</button>
                        </form>
                    </Modal.Body>
                </Modal>
            </main>
        </div>
    )
}

export default withRouter(ReportList);


// WEBPACK FOOTER //
// ./src/components/Insights/reportlist.js